/**
 * PandaAnimation — the flagship 5,000-coin gift.
 * Big panda emoji lands with a bounce, rainbow confetti explodes outward,
 * gold "★ 5000 ★" halo pulses. Most extravagant animation in the set.
 */
export default function PandaAnimation({ size = 140 }) {
  const confetti = [
    { dx: "-70px", dy: "-40px", color: "#f43f5e", delay: "0.15s", rot: "540deg" },
    { dx: "60px",  dy: "-50px", color: "#f97316", delay: "0.2s",  rot: "-480deg" },
    { dx: "-80px", dy: "20px",  color: "#fbbf24", delay: "0.25s", rot: "600deg" },
    { dx: "70px",  dy: "30px",  color: "#22c55e", delay: "0.3s",  rot: "-540deg" },
    { dx: "-40px", dy: "-70px", color: "#06b6d4", delay: "0.35s", rot: "440deg" },
    { dx: "40px",  dy: "-70px", color: "#8b5cf6", delay: "0.4s",  rot: "-500deg" },
    { dx: "-90px", dy: "-10px", color: "#ec4899", delay: "0.45s", rot: "480deg" },
    { dx: "85px",  dy: "0px",   color: "#3b82f6", delay: "0.5s",  rot: "-460deg" },
  ];
  return (
    <div
      className="pointer-events-none"
      style={{ width: size, height: size, position: "relative" }}
    >
      <style>{`
        @keyframes panda-arrive {
          0%   { transform: translateY(60px) scale(0.3) rotate(-20deg); opacity: 0; filter: drop-shadow(0 0 0 rgba(251,191,36,0)); }
          25%  { transform: translateY(-14px) scale(1.7) rotate(6deg); opacity: 1; filter: drop-shadow(0 0 44px rgba(251,191,36,0.95)); }
          45%  { transform: translateY(0px) scale(1.4) rotate(-3deg); opacity: 1; filter: drop-shadow(0 0 40px rgba(244,63,94,0.9)); }
          65%  { transform: translateY(-4px) scale(1.5) rotate(2deg); opacity: 1; filter: drop-shadow(0 0 40px rgba(251,191,36,0.9)); }
          100% { transform: translateY(0) scale(1.2) rotate(0deg); opacity: 0; filter: drop-shadow(0 0 0 rgba(251,191,36,0)); }
        }
        @keyframes panda-confetti {
          0%   { transform: translate(0, 0) rotate(0deg) scale(0.3); opacity: 0; }
          20%  { opacity: 1; }
          100% { transform: translate(var(--dx, 0), var(--dy, 0)) rotate(var(--rot, 360deg)) scale(1); opacity: 0; }
        }
        @keyframes panda-halo {
          0%   { transform: scale(0.4); opacity: 0; }
          40%  { transform: scale(1.4); opacity: 0.8; }
          100% { transform: scale(1.8); opacity: 0; }
        }
      `}</style>
      {/* Gold halo */}
      <div
        style={{
          position: "absolute",
          inset: "15%",
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(251,191,36,0.5), rgba(244,63,94,0.3), transparent 70%)",
          animation: "panda-halo 1.4s ease-out forwards",
        }}
      />
      {/* Rainbow confetti */}
      {confetti.map((c, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            width: 10,
            height: 14,
            background: c.color,
            borderRadius: 2,
            transform: "translate(-50%, -50%)",
            animation: `panda-confetti 1.4s ease-out ${c.delay} forwards`,
            "--dx": c.dx,
            "--dy": c.dy,
            "--rot": c.rot,
            boxShadow: `0 0 8px ${c.color}`,
          }}
        />
      ))}
      {/* Panda */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          fontSize: size * 0.72,
          lineHeight: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animation: "panda-arrive 1.4s cubic-bezier(.22,1,.36,1) forwards",
        }}
      >
        🐼
      </div>
    </div>
  );
}
